export const SET_ERROR = "SET_ERROR";
export const NETWORK_ERROR_CODE = -1;